import styled from 'styled-components';

import { theme } from '@styles/theme';

export const MobileActions = styled.div({
  width: '100%',
  padding: `${theme.space[4]} ${theme.space[6]}`,
  backgroundColor: theme.color.backgroundLightDark,
});
